import type { LocalePack } from './types.js';

/** Polish (Polski) */
export const pl: LocalePack = {
  headerTitle: 'Edytor zdjęć',
  headerSubtitle: 'Edytuj obraz z łatwością',
  applyButton: 'Zastosuj',
  cancelButton: 'Zamknij',
  undo: 'Cofnij',
  redo: 'Ponów',
  fullscreen: 'Pełny ekran',
  fit: 'Dopasuj',
  zoomTooltip: 'Powiększenie · +/− · 0 dopasuj · 1 100%',

  emptyStateTitle: 'Upuść obraz lub kliknij, aby przesłać',
  emptyStateSubtitle: 'Obsługiwane: PNG, JPEG, HEIC',

  calloutLabelText: 'Etykieta',

  tool: {
    select: 'Zaznacz',
    crop: 'Przytnij',
    draw: 'Rysuj',
    eraser: 'Gumka',
    text: 'Tekst',
    shapes: 'Kształty',
    callout: 'Notatka',
    filters: 'Filtry',
    adjust: 'Dostosuj',
    move: 'Przesuń',
    pen: 'Pióro',
    zoom: 'Powiększenie',
    zoomIn: 'Powiększ',
    zoomOut: 'Pomniejsz',
    rotateLeft: 'Obróć w lewo',
    rotateRight: 'Obróć w prawo',
    flipH: 'Odbij poziomo',
    flipV: 'Odbij pionowo',
    reset: 'Resetuj',
  },

  shape: {
    circle: 'Koło',
    ellipse: 'Elipsa',
    square: 'Kwadrat',
    rectangle: 'Prostokąt',
    arrow: 'Strzałka',
    polyline: 'Ścieżka linii',
  },

  filter: {
    none: 'Oryginał',
    grayscale: 'Cz/B',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Chłodny',
    warm: 'Ciepły',
    invert: 'Odwróć',
  },

  props: {
    title: {
      draw: 'Rysuj',
      eraser: 'Gumka',
      text: 'Tekst',
      crop: 'Przytnij',
      shapes: 'Kształty',
      callout: 'Notatka',
      filters: 'Filtry',
      adjust: 'Dostosuj',
      move: 'Przesuń',
    },
    aspectRatio: 'Proporcje',
    applyCrop: 'Zastosuj kadrowanie',
    cancel: 'Anuluj',
    shape: 'Kształt',
    preset: 'Ustawienie',
    resetEffects: 'Resetuj efekty',
    resetAdjustments: 'Resetuj dostosowania',
    deleteSelected: 'Usuń zaznaczone',
    colors: 'Kolory',
    recent: 'Ostatnie',
    customColor: 'Kolor niestandardowy',
    brushSize: 'Rozmiar pędzla',
    strokeWidth: 'Grubość linii',
    opacity: 'Krycie',
    eraserSize: 'Rozmiar gumki',
    fontSize: 'Rozmiar czcionki',
    brightness: 'Jasność',
    contrast: 'Kontrast',
    saturation: 'Nasycenie',
    blur: 'Rozmycie',
    quickActions: 'Szybkie akcje',
    hintMove:
      'Przeciągnij, aby przesunąć · szczypnij lub przewiń, aby powiększyć · wybierz narzędzie, aby zacząć.',
    hintEraser: 'Dotknij lub przeciągnij nad adnotacją, aby ją usunąć.',
  },
};
